export const SHOPIFY_API_VERSION = '2026-04'
